module.exports = __webpack_public_path__ + "img/icon_email.7e52d6b4.svg";